import { useEffect, useMemo, useState } from "react";
import { useLanguage } from "../../../stores/LanguageStore";
import dayjs from "dayjs";
import { ActionIcon, Button, Group, Select, Tooltip } from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { IconClock } from "@tabler/icons-react";
import RelativeDateSelector from "./RelativeDateSelector";
import { parseStrToStates } from "../../../functions/utilFunctions";

const FilterDateSelector = ({
  placeholder,
  disabled,
  setValue,
  value,
  setCondition,
  field_name,
  pageName,
  isMobile,
  readOnly,
}) => {
  const lang = useLanguage((s) => s.language);
  // const relativeDates = useMemo(() => {
  //   return [
  //     {
  //       value: "today",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.today,
  //     },
  //     {
  //       value: "-1 day",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.past_1,
  //       type: "Passé",
  //     },
  //     {
  //       value: "-2 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.past_2,
  //       type: "Passé",
  //     },
  //     {
  //       value: "-3 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.past_3,
  //       type: "Passé",
  //     },
  //     {
  //       value: "-4 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.past_4,
  //       type: "Passé",
  //     },
  //     {
  //       value: "-5 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.past_5,
  //       type: "Passé",
  //     },
  //     {
  //       value: "-6 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.past_6,
  //       type: "Passé",
  //     },
  //     {
  //       value: "-7 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.past_7,
  //       type: "Passé",
  //     },
  //     {
  //       value: "-30 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.past_30,
  //       type: "Passé",
  //     },
  //     {
  //       value: "+1 day",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.future_1,
  //       type: "Futur",
  //     },
  //     {
  //       value: "+2 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.future_2,
  //       type: "Futur",
  //     },
  //     {
  //       value: "+3 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.future_3,
  //       type: "Futur",
  //     },
  //     {
  //       value: "+4 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.future_4,
  //       type: "Futur",
  //     },
  //     {
  //       value: "+5 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.future_5,
  //       type: "Futur",
  //     },
  //     {
  //       value: "+6 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.future_6,
  //       type: "Futur",
  //     },
  //     {
  //       value: "+7 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.future_7,
  //       type: "Futur",
  //     },
  //     {
  //       value: "+30 days",
  //       label: lang.table.toolbar.filter.filters_list_label.dates.future_30,
  //       type: "Futur",
  //     },
  //   ];
  // }, [lang]);

  const [isExact, setIsExact] = useState(value?.includes?.("Z") ? true : false);
  // const [dayOnly, setDayOnly] = useState(value?.includes?.("Z") ? false : true);

  // useEffect(() => {
  //   if (isExact) {
  //     const actual = dayjs()
  //       .set("h", 0)
  //       .set("minutes", 0)
  //       .set("second", 0)
  //       .set("milliseconds", 0);
  //     let d = actual;
  //     setValue(dayOnly ? d?.format("YYYY-MM-DD") : d?.toISOString());
  //     setDayOnly(value?.length > 12 ? false : true);
  //   }
  // }, [isExact]);

  return (
    <Group wrap="nowrap">
      {isExact ? (
        <>
          <DateTimePicker
            placeholder={placeholder}
            w={isMobile ? "100%" : 172}
            value={value?.includes("Z") ? new Date(value) : new Date()}
            disabled={disabled}
            radius={"md"}
            onChange={(d) => {
              setValue(new Date(d).toISOString());
            }}
            valueFormat={"DD / MM / YYYY      HH : mm"}
            popoverProps={{
              zIndex: 1500,
            }}
            readOnly={readOnly}
          />

          {/* <Tooltip label={!dayOnly ? "Avec heures" : "Sans heures"}> */}
          {/* <ActionIcon
            variant={dayOnly ? "default" : "filled"}
            onClick={() => {
              setDayOnly(!dayOnly);
            }}
          >
            <IconClock size={18} />
          </ActionIcon> */}
          {/* </Tooltip> */}
        </>
      ) : (
        <RelativeDateSelector
          field_name={field_name}
          value={value}
          setValue={setValue}
          readOnly={readOnly}
        />
      )}
      {(pageName === "prm" || pageName === "campaigns") && (
        <Button
          size="xs"
          variant="outline"
          onClick={() => {
            if (isExact) {
              setCondition("more_than");
            } else {
              setValue(new Date(parseStrToStates(value)?.date).toISOString());
            }
            setIsExact(!isExact);
          }}
          disabled={readOnly}
          // sx={{ ml: 1, height: 21, fontSize: 10, fontWeight: "bold", width: 64 }}
          // color="secondary"
        >
          {isExact ? "relative" : "exact"}
        </Button>
      )}
    </Group>
  );
};

export default FilterDateSelector;
